<div *ngIf="providers && providers.length" class="ui floating message margin-bottom-20">
    <div class="content">
        <div class="header">Searched these authorized {{ 'integration' | plural: providers.length }}:</div>

        <div class="integrations-wrapper">
            <div *ngFor="let provider of providers">
                <img src="/assets/images/partners/{{ MAP[provider] || provider + '.png' }}" />
                <span>{{ provider | capitalize }}</span>
            </div>
            <a href="/settings/accounts/add#search" target="_blank">+Add More</a>
        </div>
    </div>
</div>

<table class="ui fluid simple table" *ngIf="results && results.length">
    <tbody style="background-color: lightgray; text-transform: uppercase;">
        <tr *ngIf="results && results.length">
            <td colspan="2">
                <h3>
                    {{ headerTitle || 'Results:' }}
                    <button class="ui right floated button" (click)="clearResults()">
                        Clear Results
                    </button>
                </h3>
            </td>
        </tr>
    </tbody>
    <tbody>
        <tr *ngFor="let result of results">
            <td>
                <b>{{ result.providerName }} {{ result.categoryName }}</b>
            </td>
            <td>
                <a *ngIf="result.url" target="_blank" href="{{ result.url }}">{{ result.itemName }}</a>
                <span *ngIf="!result.url">{{ result.itemName }}</span>
            </td>
        </tr>
    </tbody>
</table>

<div *ngIf="results && !results.length && !isEmptyState" class="ui info message">
    No results
    <span *ngIf="providers && providers.length"
        >from your {{ providers | capitalize: true | listNames }} {{ 'integration' | plural: providers.length }}.</span
    >
    <a href="/settings/accounts/add#search">+Add More Integrations</a>
</div>
